var AppDispatcher = require('../core/AppDispatcher.jsx');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('lodash');
var ApplicationHelper = require('../utils/ApplicationHelper');
var Products = require('../utils/Products.js');
var DownloadFormsHelper = require('../utils/DownloadFormsHelper.js').default;
var IdVerificationHelper = require('../utils/IdVerificationHelper.js').default;
var ConsolidateInvestmentOptionsHelper = require('../utils/ConsolidateInvestmentOptionsHelper.js').default;

//constants
var CHANGE_EVENT = 'change';
var Constants = require('../constants/ApplicationConstants.js');
var ProductIds = Constants.ProductIds;
var ApplicationConstants = require('../constants/ApplicationConstants.js');
var ActionTypes = ApplicationConstants.ActionTypes;
var AccountTypeActionsTypes = require('../constants/AccountTypeConstants.js').ActionTypes;
var SelectCustomerActionsTypes = require('../constants/SelectCustomerConstants.js').ActionTypes;
var DownloadConstants = require('../constants/DownloadConstants.js');
//stores
var AccountTypeStore = require('./AccountTypeStore.js');
var YourDetailsStore = require('./YourDetailsStore');
var BusinessYourDetailsStore = require('./BusinessYourDetailsStore.js');
var InvestmentAllocationStore = require('./InvestmentAllocationStore.js');
var ModelPortfolioStore = require('./ModelPortfolioStore.js');
var AdviceFeeStore = require('./AdviceFeeStore.js');
var AutoRebalancingStore = require('./AutoRebalancingStore.js');
var OnlineAccessStore = require('./OnlineAccessStore.js');
var PortfolioRebateStore = require('./PortfolioRebateStore.js');
var RegularInvestmentPlanStore = require('./RegularInvestmentPlanStore.js');
var FundingYourProductStore = require('./FundingYourProductStore.js');
var InSpecieTransferStore = require('./InSpecieTransferStore.js').default;
var PensionPaymentStore = require('./PensionPaymentStore.js').default;
var PensionTypeStore = require('./PensionTypeStore.js').default;
var AccountSettingsStore = require('./AccountSettingsStore.js').default;
var SuperFirstTransferStore = require('./SuperFirstTransferStore.js').default;
var BeneficiaryDetailsStore = require('./BeneficiaryDetailsStore.js').default;
var SpecialRequestsStore = require('./SpecialRequestsStore.js').default;
var AdviserAuthorityStore = require('./AdviserAuthorityStore.js').default;
var AdviserAttestationStore = require('./AdviserAttestationStore.js').default;
var IncomeDistributionStore = require('./IncomeDistributionStore.js').default;
var IDVerificationStore = require('./IDVerificationStore.js').default;
var ApplicationModeProcessor = require('../utils/ApplicationModeProcessor.js').default;

var _sectionVisibility = {
    accountType: false,
    yourDetails: false,
    pensionType: false,
    investmentAllocation: false,
    adviserFee: false,
    autoRebalancing: false,
    onlineAccess: false,
    portfolioRebate: false,
    fundingYourProduct: false,
    regularInvestmentPlan: false,
    superFirstTransfer: false,
    pensionPayment: false,
    accountSettings: false,
    beneficiaryDetails: false,
    specialRequests: false,
    incomeDistribution: false,
    inSpecieTransfer: false,
    adviserAuthority: false,
    adviserAttestation: false
}

let _clientIdentificationMode = { isReady: false };
var _productHeader = { value: '', label: '' };
var _hideErrorBar = true;
var _productList = [], _errorList = [];
var _storeReadyForSave = false, _storeReadyForReview = false;
var _applicationId = '';
var _productId, _clientOin, _applicationLinkType;
var _userType = window.NOA ? window.NOA.userContext.userType : '';
var _fieldWithErrorId = '';
var _accountType = '';
var _formModel = _.clone(Constants.FormModel);
var _consolidatedFormModel = null;
var _validForReview = false, _validForSave = false;
var _allocationAssets = [];
var _inSpecieAllocationAssets = [];
var _showMoreMenu = false;
var _sectionId;
var _isSaveDisabled = false;
var _isEmulation = window.NOA ? window.NOA.userContext.isEmulation : false;
var _kycFlag = false;
var _hasDigitalSignature = '', _digitalSignatureTimeStamp;
var _jointInvestorDetails = {},
    _showDownloadMenu = false,
    _formsToDownload = [],
    _downloadInProgress = false,
    _selectedForms = [],
    _readyForDownload = false,
    _downloadedForms = '',
    _formDownloaded = true,
    _downloadFormsFailed = false,
    _originationSource = ApplicationConstants.OriginationSources.FIRSTNET,
    _originationType,
    _wipId = '';
var _companyCode = window.NOA ? window.NOA.userContext.companyCode : '001';

function retireveApplication(applicationData) {
    appInit(applicationData.productId);
    setKycFlag(applicationData.form.yourDetails.kycFlag);
    setApplicationId(applicationData.id, applicationData.wipId);
    setAccountType(applicationData.form.accountType);
    setApplicationLinkType(applicationData.applicationLinkType);
    _hasDigitalSignature = applicationData.hasDigitalSignature;
    _digitalSignatureTimeStamp = applicationData.digitalSignatureTimeStamp;
    _originationSource = applicationData.originationSource;
    _originationType = applicationData.originationType;
}

function setApplicationLinkType(applicationLinkType) {
    _applicationLinkType = applicationLinkType;
}

function loadProductList(productList) {
    _productList = productList;
    trySetProductHeader();
}

//sets section visibility based on product selected
function setSectionVisibility() {
    //default values to all false
    _sectionVisibility.accountType = false;
    _sectionVisibility.yourDetails = false;
    _sectionVisibility.investmentAllocation = false;
    _sectionVisibility.adviserFee = false;
    _sectionVisibility.autoRebalancing = false;
    _sectionVisibility.onlineAccess = false;
    _sectionVisibility.portfolioRebate = false;
    _sectionVisibility.fundingYourProduct = false;
    _sectionVisibility.regularInvestmentPlan = false;
    _sectionVisibility.superFirstTransfer = false;
    _sectionVisibility.inSpecieTransfer = false;
    _sectionVisibility.pensionPayment = false;
    _sectionVisibility.pensionType = false;
    _sectionVisibility.accountSettings = false;
    _sectionVisibility.beneficiaryDetails = false;
    _sectionVisibility.specialRequests = false;
    _sectionVisibility.incomeDistribution = false;
    // set visible to true for all the sections we are supposed to show (whitelist) - easy to read
    switch (_productId) {
        case ProductIds.SUPER:
            _sectionVisibility.yourDetails = true;
            _sectionVisibility.investmentAllocation = true;
            _sectionVisibility.autoRebalancing = true;
            _sectionVisibility.portfolioRebate = true;
            _sectionVisibility.fundingYourProduct = true;
            _sectionVisibility.regularInvestmentPlan = true;
            setOnlineAccessSectionVisibility();
            setAdviceFeeVisibility();
            setAdviserAuthorityVisibility();
            setAdviserAttestationVisibility();
            break;
        case ProductIds.PENSION:
            _sectionVisibility.investmentAllocation = true;
            _sectionVisibility.yourDetails = true;
            _sectionVisibility.autoRebalancing = true;
            _sectionVisibility.portfolioRebate = true;
            _sectionVisibility.fundingYourProduct = true;
            setOnlineAccessSectionVisibility();
            _sectionVisibility.superFirstTransfer = true;
            _sectionVisibility.inSpecieTransfer = true;
            _sectionVisibility.pensionPayment = true;
            _sectionVisibility.pensionType = true;
            _sectionVisibility.beneficiaryDetails = true;
            if (window.NOA.userContext.isExisting) {
                _sectionVisibility.specialRequests = true;
            }
            setAdviceFeeVisibility();
            setAdviserAuthorityVisibility();
            setAdviserAttestationVisibility();
            break;
        case ProductIds.INVESTMENT:
            _sectionVisibility.accountType = true;
            _sectionVisibility.investmentAllocation = true;
            _sectionVisibility.autoRebalancing = true;
            _sectionVisibility.portfolioRebate = true;
            _sectionVisibility.fundingYourProduct = true;
            _sectionVisibility.regularInvestmentPlan = true;
            _sectionVisibility.incomeDistribution = true;
            setAdviceFeeVisibility();
            setAdviserAuthorityVisibility();
            setAdviserAttestationVisibility();
            break;
        case ProductIds.COMMINSURE:
            _sectionVisibility.accountType = true;
            _sectionVisibility.fundingYourProduct = false;
            break;
        case ProductIds.CHALLENGER:
            _sectionVisibility.accountType = true;
            _sectionVisibility.fundingYourProduct = false;
            break;

        default:
            return;
    }
}

function setKycFlag(kycFlag) {
    _kycFlag = kycFlag;
}

function setOnlineAccessSectionVisibility() {
    var userContext = window.NOA.userContext || {};
    
    if (userContext.isAdviser) {
        // client OIN could be set from FirstNet via bootstrap model or by selecting an existing one in client select page
        _sectionVisibility.onlineAccess = !!(!_clientOin && !userContext.investorOin);
    } else if (userContext.isInvestor) {
        _sectionVisibility.onlineAccess = !userContext.isExisting;
    } else {
        _sectionVisibility.onlineAccess = false;
    }
}

function setClientOin(clientOin) {
    _clientOin = clientOin;
    window.NOA.userContext.investorOin = clientOin;
}

function trySetProductHeader() {
    var foundProduct;
    if (_productId && _productList && _productList.length > 0) {
        foundProduct = _.find(_productList, { value: _productId });
    }

    if (foundProduct) {
        _productHeader = _.clone({ value: foundProduct.value, label: foundProduct.label });
    }
}

function setProduct(productId) {
    _productId = productId;
    trySetProductHeader();
}

function appInit(productId) {
    setProduct(productId);
    setSectionVisibility();
    resetDownloadMenu();
}

function showYourDetails() {
    _sectionVisibility.yourDetails = true;
}

function setApplicationId(id, wipId) {
    _applicationId = id;
    _formModel.id = id;
    if (wipId) {
        _wipId = wipId;
    }
}

function getFormModelsForReview(withShellAccount) {
    getFormModels();
    var processMode = ApplicationModeProcessor.getProcessModeByAppData(_formModel);
    ApplicationHelper.setApplicationProcessMode(_formModel, processMode);
    _storeReadyForReview = withShellAccount || !_formModel.isApplicationDataNotReadyForFunding;
    _consolidatedFormModel = ConsolidateInvestmentOptionsHelper.getSubmissionFormModel(_formModel, _productId);
}

function getFormModelsForSave() {
    getFormModels();
    _storeReadyForSave = true;
}

function getFormModels() {
    _formModel.id = _applicationId;
    _formModel.wipId = _wipId;
    _formModel.productId = _productId;
    _formModel.form.accountType = AccountTypeStore.getAccountType();
    _formModel.applicationLinkType = _applicationLinkType;
    _formModel.submitDate = '';
    _formModel.submitFlag = false;
    _formModel.originationSource = _originationSource;
    _formModel.originationType = _originationType;
    _formModel.hasDigitalSignature = _hasDigitalSignature;
    _formModel.digitalSignatureTimeStamp = _digitalSignatureTimeStamp;
    _formModel.isFirstNetClient = YourDetailsStore.getFirstNetClient();
    _formModel.hasCustomTitle = YourDetailsStore.getHasCustomTitle();
    //if NOT business type then use (personal)yourDetailsStore else businessYourDetailsStore
    if (!ApplicationHelper.isBusinessAccountType(_formModel.form.accountType)) {
        _formModel.form.yourDetails = YourDetailsStore.getYourDetailsModel();
        //FOR ADDING MULTIPLE INVESTOR OIN IS IN PLACE!!
        if (_formModel.form.accountType === ApplicationConstants.AccountTypeCodes.JOINT && Products.isInvestment(_productId)) {
            for (let i = 0; i < ApplicationConstants.MaxNumberOfInvestor; i++) {
                let jointInvestorDetails = _.get(_jointInvestorDetails, 'investor'.concat(i + 1), null);
                if (_formModel.form.yourDetails.investorList[i] && jointInvestorDetails) {
                    if (jointInvestorDetails.oin && jointInvestorDetails.kyc) {
                        _formModel.form.yourDetails.investorList[i].oin = jointInvestorDetails.oin;
                        _formModel.form.yourDetails.investorList[i].kycFlag = jointInvestorDetails.kyc;
                    }
                    if (jointInvestorDetails.cif) {
                        _formModel.form.yourDetails.investorList[i].cif = jointInvestorDetails.cif;
                    }
                }
            }
        }
    } else {
        _formModel.form.yourDetails = BusinessYourDetailsStore.getYourDetailsModelForSave();
        var yourDetailsModel = YourDetailsStore.getYourDetailsModel();
        _formModel.form.yourDetails.investorList = yourDetailsModel.investorList;
        _formModel.form.yourDetails.trusteeList = yourDetailsModel.trusteeList;
    }

    _formModel.form.investmentAllocation = InvestmentAllocationStore.getInvestmentAllocationData();
    if (_formModel.form.investmentAllocation) {
        _formModel.form.investmentAllocation.ModelPortfolioId = ModelPortfolioStore.getSelected();
        _formModel.form.investmentAllocation.assetAllocations = _allocationAssets;
        _formModel.form.investmentAllocation.inSpecieAssetAllocations = _inSpecieAllocationAssets;
        _formModel.form.investmentAllocation.isManagedAccount = ModelPortfolioStore.getIsManagedAccount();
        _formModel.form.investmentAllocation.managedAccountName = ModelPortfolioStore.getManagedAccountName();
        _formModel.form.investmentAllocation.isFirstRateCashNonAutoRebalancing = InvestmentAllocationStore.getFirstRateCashNonAutoRebalancing();
    }

    _formModel.form.inSpecieTransfer = InSpecieTransferStore.getFormModel();
    if (_formModel.form.inSpecieTransfer && _formModel.form.investmentAllocation) {
        _formModel.form.inSpecieTransfer.externalAllocations = _formModel.form.investmentAllocation.investmentOptions;
    }
    _formModel.form.adviceFee = AdviceFeeStore.getAdviceFeeModel();
    _formModel.form.autoRebalancing = AutoRebalancingStore.getAutoRebalancingModel();
    _formModel.form.onlineAccess = OnlineAccessStore.getOnlineAccessModel();
    getOnlineAccessModel();
    _formModel.form.portfolioRebate = PortfolioRebateStore.getPortfolioRebateModel();
    _formModel.form.regularInvestmentPlan = RegularInvestmentPlanStore.getRegInvstPlanModel();
    _formModel.form.fundingYourProduct = FundingYourProductStore.getFypFormModel();
    _formModel.form.pensionPayment = PensionPaymentStore.getPensionPaymentModel();
    _formModel.form.accountSettings = AccountSettingsStore.getModel();
    _formModel.form.pensionType = PensionTypeStore.getPensionTypeModel();
    _formModel.form.superFirstTransfer = SuperFirstTransferStore.getFormModel();
    _formModel.form.beneficiary = BeneficiaryDetailsStore.getBeneficiaryModel();
    _formModel.form.specialRequests = SpecialRequestsStore.getSpecialRequestsModel();
    _formModel.form.adviserAuthority = AdviserAuthorityStore.getAdviserAuthorityModel();
    _formModel.form.adviserAttestation = AdviserAttestationStore.getAdviserAttestationModel();
    _formModel.form.incomeDistribution = IncomeDistributionStore.getIncomeDistributionModel();
    _formModel.form.memberAttestation = InvestmentAllocationStore.getMemberAttestationModel();
    getIDVerificationModelMapper();
    getTfnPlaceHolders();
    _formModel.complete = true;
}

function getIDVerificationModelMapper() {
    const idVerificationModel = getIDVerificationModel();

    // idVerification contains meta data for user input
    _formModel.form.idVerification = idVerificationModel;

    // map back to verificationDocuments for application save / submit
    _formModel.form.yourDetails = IdVerificationHelper.formatVerificationDocuments(_formModel.productId, _formModel.form.accountType, _formModel.form.yourDetails, idVerificationModel);
}

function getIDVerificationModel() {
    let model = IDVerificationStore.getIDVerificationModel();
    let titleList = YourDetailsStore.getTitleList();
    model = IdVerificationHelper.getUpdatedInvestorDetails(_formModel.form.yourDetails, titleList, model);
    return model;
}

function getTfnPlaceHolders() {
    let idx = 0;
    if (_formModel.form.yourDetails && _formModel.form.yourDetails.tfnInfo) {
        _formModel.form.yourDetails.tfnInfo.tfnPlaceHolder = ('tfn_').concat(idx++);
    }
    if (_formModel.form.yourDetails && _formModel.form.yourDetails.investorList) {
        _.each(_formModel.form.yourDetails.investorList, investor => {
            if (investor.tfnInfo) {
                investor.tfnInfo.tfnPlaceHolder = ('tfn_').concat(idx++);
            }
        });
    }
    if (_formModel.form.yourDetails && _formModel.form.yourDetails.trusteeList) {
        _.each(_formModel.form.yourDetails.trusteeList, trustee => {
            if (trustee.tfnInfo) {
                trustee.tfnInfo.tfnPlaceHolder = ('tfn_').concat(idx++);
            }
        });
    }
}

function getOnlineAccessModel(){
    var onlineAccessModel = OnlineAccessStore.getOnlineAccessModel();
    if (!onlineAccessModel) {
        return;
    }
    var yourDetails = _formModel.form.yourDetails;
    var oaIndex = 0, list = [];
    if (_formModel.form.accountType !== ApplicationConstants.AccountTypeCodes.JOINT){
        _.assign(yourDetails, onlineAccessModel[oaIndex]);
        oaIndex++;
    }
    if (yourDetails.investorList.length > 0){
        list = yourDetails.investorList;
    }
    else if (yourDetails.trusteeList.length > 0){
        list = yourDetails.trusteeList;
    }

    for (var i = 0; i < list.length; i++, oaIndex++){
        _.assign(list[i], onlineAccessModel[oaIndex]);
    }
}

function clearFormModels() {
    _formModel = _.clone(Constants.FormModel);
    _validForReview = false;
    _validForSave = false;
    _storeReadyForReview = false;
    _storeReadyForSave = false;
}

function showErrorBar(errorBarShown) {
    _hideErrorBar = !errorBarShown
}

function receiveAssetAllocations(data, isInSpecie) {
    const allocationsPerInvestment = _.filter(data, { rateType: 'B' });
    if (isInSpecie) {
        _inSpecieAllocationAssets = allocationsPerInvestment;
    } else {
        _allocationAssets = allocationsPerInvestment;
    }
}

function clearErrorList() {
    _errorList = [];
    _hideErrorBar = true;
}

function setFieldWithErrorId(id) {
    _fieldWithErrorId = id;
}

function validateApplicationForSave() {
    var errors = [];

    errors = errors.concat(AccountTypeStore.getSummaryErrorList() || []);
    if (ApplicationHelper.isBusinessAccountType(_accountType)) {
        errors = errors.concat(BusinessYourDetailsStore.getErrorListForSummary() || []);
    }

    errors = errors.concat(YourDetailsStore.getValidationSummary() || []);

    _validForSave = errors.length ===  0;

    if (errors.length > 0) {
        _errorList = [];
        _errorList = _errorList.concat(errors);
    }
}

function validateApplication() {
    var errors = [];
    _errorList = [];

    errors = errors.concat(AccountTypeStore.getSummaryErrorList() || []);

    if (ApplicationHelper.isBusinessAccountType(_accountType)) {
        errors = errors.concat(BusinessYourDetailsStore.getErrorListForSummary());
    }
    errors = errors.concat(YourDetailsStore.getValidationSummary() || []);

    errors = errors.concat(AccountSettingsStore.getSummaryError() || []);

    errors = errors.concat(PensionTypeStore.pensionTypeErrorMessages() || []);

    errors = errors.concat(FundingYourProductStore.getSectionErrors() || []);

    errors = errors.concat(InSpecieTransferStore.getSummaryErrors() || []);

    var investmentAllocationErrors = InvestmentAllocationStore.getErrorList();
    if (investmentAllocationErrors) {
        errors = errors.concat(investmentAllocationErrors.toArray()[0]);
    }

    errors = errors.concat(RegularInvestmentPlanStore.getErrorList() || []);

    errors = errors.concat(PensionPaymentStore.pensionPaymentErrorMessages() || []);

    errors = errors.concat(AutoRebalancingStore.getErrorList() || []);

    errors = errors.concat(OnlineAccessStore.getValidationSummary() || []);

    errors = errors.concat(IncomeDistributionStore.getSummaryErrorList() || []);

    errors = errors.concat(AdviceFeeStore.adviceFeeErrorMessages() || []);

    errors = errors.concat(BeneficiaryDetailsStore.getSummaryError() || []);

    errors = errors.concat(AdviserAuthorityStore.getSummaryErrorList() || []);

    errors = errors.concat(AdviserAttestationStore.getSummaryErrorList() || []);

    _validForReview = errors.length === 0;

    if (errors.length > 0) {
        _errorList = _errorList.concat(errors);
    } else {
        _errorList = [];
    }
}

function setAccountType(accountType) {
    showYourDetails();
    _sectionVisibility.accountSettings = Products.isAnnuity(_productId);
    setOnlineAccessSectionVisibility();
    _accountType = accountType;
    resetDownloadMenu();
}

function setAdviceFeeVisibility() {
    var user = window.NOA.userContext;
    if (user && user.isAdviser && user.isExisting) {
        _sectionVisibility.adviserFee = true;
    }
}
function setAdviserAuthorityVisibility() {
    var user = window.NOA.userContext;
    if (user && user.isAdviser) {
        _sectionVisibility.adviserAuthority = true;
    }
}

function setAdviserAttestationVisibility() {
    var user = window.NOA.userContext;
    if (user && user.isAdviser) {
        _sectionVisibility.adviserAttestation = true;
    }
}

function showMoreMenu(answer) {
    _showMoreMenu = answer;
}

function setJointInvestorDetails(data) {
    _jointInvestorDetails = _.cloneDeep(data);
}

function updateFormModelIdVerification(idVerificationModel) {
    _formModel.form.idVerification = _.cloneDeep(idVerificationModel);
}

function resetDownloadMenu() {
    _showDownloadMenu = false;
    _formsToDownload = [];
}

function toggleDownloadMenu(showDownloadMenu) {
    _showDownloadMenu = showDownloadMenu;
    if (showDownloadMenu) {
        _formsToDownload = DownloadFormsHelper.getFormsList(_productId, _accountType);
    } else {
        _formsToDownload = [];
    }
    _selectedForms = [];
    _downloadInProgress = false;
    _downloadFormsFailed = false;
}

function updateFormsToDownload(index, checked) {
    if (_formsToDownload[index]) {
        _formsToDownload[index].checked = checked;
    }
}

function getSelectedForms() {
    if (_formsToDownload && _formsToDownload.length > 0) {
        _selectedForms = DownloadFormsHelper.getSelectedForms(_formsToDownload);
        _downloadInProgress = true;
    }
}

function getFormModelsForDownload() {
    getFormModels();
    _readyForDownload = true;
}

function receiveDownloadedApplicationForm(data) {
    if (data.attachments && data.attachments.length > 0) {
        var url = DownloadConstants.Base64String;
        _downloadedForms = url.replace('{contentType}', data.attachments[0].contentType).replace('{base64}', data.attachments[0].body);
    }
    _downloadFormsFailed = false;
    _formDownloaded = false;
    _downloadInProgress = false;
    _showDownloadMenu = false;
    _formsToDownload = [];
    _selectedForms = [];
}

function updateIsSaveDisabled(data) {
    _isSaveDisabled = data;
}

function setIdentificationMode(data) {
    //clientIdentificationMode value determines whether to transition to KYC/Confirm Details page.
    _clientIdentificationMode = data;
    _clientIdentificationMode.isReady = true;
    _formModel = IdVerificationHelper.getUpdateFormModelWithKycTypeToUpdate(_formModel, data.kycTypeToUpdate);
}

var ApplicationStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    /**
     * @param {function} callback
     */
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    /**
     * @param {function} callback
     */
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    hideModelPortfolio: function () {
        if (_userType === Constants.UserTypes.ADVISER) {
            return false;
        }
        else {
            return true;
        }
    },

    hideDownloadText: function () {
        if (_userType === Constants.UserTypes.ADVISER) {
            return false;
        }
        else {
            return true;
        }
    },

    isEmulation: function () {
        return _isEmulation;
    },

    getProductList: function () {
        return _productList;
    },

    getProduct: function () {
        return _productHeader;
    },

    getSectionVisibility: function () {
        return _sectionVisibility;
    },

    getProductId: function () {
        return _productId;
    },

    getAccountType: function () {
        return _accountType;
    },

    applicationId: function () {
        return _applicationId;
    },
    errorList: function () {
        return _errorList;
    },
    hideErrorBar: function () {
        return _hideErrorBar;
    },
    getFieldWithErrorId: function () {
        return _fieldWithErrorId;
    },
    getUserType: function () {
        return _userType;
    },
    getFormModel: function () {
        return _formModel;
    },
    getConsolidatedFormModel: function() {
        return _consolidatedFormModel ? _consolidatedFormModel : _formModel;
    },
    getShowHideMore: function () {
        return _showMoreMenu;
    },
    getClientOin: function () {
        return _clientOin;
    },
    getSectionId: function () {
        return _sectionId;
    },
    getKYCFlag: function () {
        return _kycFlag;
    },
    getDigitalSignatureFlag: function () {
        return _hasDigitalSignature;
    },
    getIDVFormStatus: function () {
        return _formModel.form.idVerification.formComplete;
    },
    getCanSaveApplication: function () {
        return _validForSave === true && _storeReadyForSave === true;
    },
    getIsSaveDisabled: function () {
        return _isSaveDisabled;
    },
    getCanReviewApplication: function () {
        return _validForReview === true && _storeReadyForReview === true;
    },
    getShowShellAccountNotification() {
        return _validForReview === true && _formModel.isApplicationDataNotReadyForFunding;
    },
    getShowDownloadMenu:function() {
        return _showDownloadMenu;
    },
    getFormsToDownload:function() {
        return _formsToDownload;
    },
    getEnableDownloadButton: function () {
        var checked = _.where(_formsToDownload, {'checked':true});
        return checked && checked.length > 0;
    },
    getDownloadInProgress: function() {
        return _downloadInProgress;
    },
    getSelectedForms: function() {
        return _selectedForms;
    },
    getReadyForDownload: function () {
        return _readyForDownload === true && _downloadInProgress === true;
    },
    getDownloadedForms:function() {
        return _downloadedForms;
    },
    getIsFormsDownloaded: function() {
        return _formDownloaded;
    },
    getDownloadFormsFailed: function () {
        if (_downloadInProgress) {
            return false;
        }
        return _downloadFormsFailed;
    },
    getClientIdentificationMode() {
        return _clientIdentificationMode;
    },
    getClientIdentificationModeQueryInfo() {
        return {
            accountType: _formModel.form.accountType,
            productId: _productId,
            clientOin: ApplicationHelper.getClientOin(_formModel),
            clientCif: ApplicationHelper.getClientCif(_formModel),
            kycFlag: ApplicationHelper.getClientKycFlag(_formModel),
            originationSource: _formModel.originationSource,
            originationType: _formModel.originationType,
            applicationLinkType: _formModel.applicationLinkType
        };
    },
    getCompanyCode: function () {
        return _companyCode;
    }
});

ApplicationStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.actionType) {
        case SelectCustomerActionsTypes.SET_CLIENT_OIN:
            setClientOin(action.clientOin);
            break;
        case ActionTypes.SET_PRODUCT_ID:
            setProduct(action.productId);
            break;
        case ActionTypes.NEW_APPLICATION_INITIALISED:
            appInit(action.productId);
            break;
        case ActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            retireveApplication(action.applicationData);
            break;
        case AccountTypeActionsTypes.SELECT_ACCOUNT_TYPE:
            setAccountType(action.accountType);
            clearFormModels();
            break;
        case ActionTypes.RECEIVE_PRODUCT_LIST:
            loadProductList(action.productList);
            break;
        case ActionTypes.APPLICATION_SAVE_SUCCESS:
            clearFormModels();
            setApplicationId(action.applicationId, action.wipId);
            break;
        case ActionTypes.APPLICATION_SAVE_VALIDATE:
            AppDispatcher.waitFor([AccountTypeStore.dispatchToken]);
            AppDispatcher.waitFor([BusinessYourDetailsStore.dispatchToken]);
            AppDispatcher.waitFor([YourDetailsStore.dispatchToken]);
            clearErrorList();
            validateApplicationForSave();
            break;
        case ActionTypes.SHOW_ERROR_BAR:
            showErrorBar(action.errorBarShown);
            break;
        case ActionTypes.CLEAR_ERROR_LIST:
            clearErrorList();
            break;
        case ActionTypes.GOTO_FIELD_WITH_ERROR:
            setFieldWithErrorId(action.data);
            break;
        case ActionTypes.APPLICATION_REVIEW_REQUEST:
            getFormModelsForReview(action.withShellAccount);
            break;
        case ActionTypes.APPLICATION_SAVE_REQUEST:
            getFormModelsForSave();
            break;
        case ActionTypes.VALIDATE_APPLICATION:
            AppDispatcher.waitFor([AccountTypeStore.dispatchToken]);
            AppDispatcher.waitFor([BusinessYourDetailsStore.dispatchToken]);
            AppDispatcher.waitFor([YourDetailsStore.dispatchToken]);
            AppDispatcher.waitFor([FundingYourProductStore.dispatchToken]);
            AppDispatcher.waitFor([InSpecieTransferStore.dispatchToken]);
            AppDispatcher.waitFor([InvestmentAllocationStore.dispatchToken]);
            AppDispatcher.waitFor([PensionPaymentStore.dispatchToken]);
            AppDispatcher.waitFor([PensionTypeStore.dispatchToken]);
            AppDispatcher.waitFor([RegularInvestmentPlanStore.dispatchToken]);
            AppDispatcher.waitFor([AutoRebalancingStore.dispatchToken]);
            AppDispatcher.waitFor([PortfolioRebateStore.dispatchToken]);
            AppDispatcher.waitFor([AdviceFeeStore.dispatchToken]);
            AppDispatcher.waitFor([OnlineAccessStore.dispatchToken]);
            AppDispatcher.waitFor([AccountSettingsStore.dispatchToken]);
            AppDispatcher.waitFor([IncomeDistributionStore.dispatchToken]);

            validateApplication();
            break;
        case ActionTypes.TOGGLE_SHELL_ACCOUNT_NOTIFICATION:
            _validForReview = false;
            break;
        case ActionTypes.REVIEW_APPLICATION:
            _validForReview = false;
            break;
            // This is the action that handles asset allocations for each investment - NOA-138, NOA-139
        case ActionTypes.RECEIVE_ASSET_ALLOCATIONS:
            receiveAssetAllocations(action.data, action.isInSpecie);
            break;
        case ActionTypes.UPDATE_VERIFICATOIN_DOCUMENT:
            updateFormModelIdVerification(action.data);
            break;
        case ActionTypes.SHOW_MORE_MENU:
            showMoreMenu(action.showMoreMenu);
            break;
        case ActionTypes.EDIT_SECTION:
            _sectionId = action.section;
            break;
        case ActionTypes.SET_APPLICATION_LINK_TYPE:
            setApplicationLinkType(action.applicationLinkType)
            break;
        case ActionTypes.SEND_INVESTOR_DETAILS_TEMP:
            setJointInvestorDetails(action.data);
            break;
        case ActionTypes.SHOW_DOWNLOAD_MENU:
            toggleDownloadMenu(action.showDownloadMenu);
            break;
        case ActionTypes.UPDATE_FORMS_TO_DOWNLOAD:
            updateFormsToDownload(action.index, action.checked);
            break;
        case ActionTypes.PREPARE_FORMS_TO_DOWNLOAD:
            getSelectedForms();
            break;
        case ActionTypes.APPLICATION_DOWNLOAD_REQUEST:
            getFormModelsForDownload();
            break;
        case ActionTypes.START_DOWNLOADING_FORMS:
            _readyForDownload = false;
            break;
        case ActionTypes.DOWNLOAD_FORMS_SUCCESS:
            receiveDownloadedApplicationForm(action.data);
            break;
        case ActionTypes.CLEAR_DOWNLOADED_FORMS:
            _downloadedForms = undefined;
            _formDownloaded = true;
            _selectedForms = [];
            break;
        case ActionTypes.DOWNLOAD_FORMS_FAILED:
            _downloadInProgress = false;
            _formDownloaded = true;
            _downloadFormsFailed = true;
            break;
        case ActionTypes.UPDATE_IS_SAVE_DISABLED:
            updateIsSaveDisabled(action.data);
            break;
        case ActionTypes.CLIENT_IDENTIFICATION_MODE_START_LOADING_IN_APPLICATION_FORM:
            _clientIdentificationMode = { isReady: false }
            break;
        case ActionTypes.CLIENT_IDENTIFICATION_MODE_LOADED_IN_APPLICATION_FORM:
            setIdentificationMode(action.data);
            break;
        default:
            return true;
    }

    // If action was responded to, emit change event
    ApplicationStore.emitChange();
    return true;
});

module.exports = ApplicationStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ApplicationStore.js